// extracted by mini-css-extract-plugin
module.exports = {"root":"ServiceSwitch_root__ah4jE","item":"ServiceSwitch_item__nmOba","activeMarker":"ServiceSwitch_activeMarker__7HHsj"};